const dualList = {
  pickedAmount: '{{picked}} de {{total}} itens selecionados',
};

export default dualList;
